export const baseUrl = "https://api.dismore.tech";

export const apiUrl = baseUrl + "/api/v1";

export const REACT_APP_API_URL = "https://api.dismore.tech/graphql/v1";
export const REACT_APP_API_KEY = "roostercoffeeindonesia";
